import useHttpQuery from 'data/firestore/useHttpQuery';
import { PAGE_SIZE } from '../../../constants';
import {
    buildWebhookLogsListSearchBody,
    buildWebhookLogsSearchPath,
} from './helpers/buildSearchBody';
import formatWebhookLogFromElasticsearch from './helpers/formatWebhookLogFromElasticsearch';
import {
    SearchWebhookLogsQuery,
    SearchWebhookLogsResponse,
    WebhookLog,
} from './types';

interface SearchWebhookLogsResult {
    data: WebhookLog[];
    total: number;
    isLoading: boolean;
    isFetching: boolean;
    error: unknown;
}

const useSearchWebhookLogs = ({
    agentId = '',
    webhookId = '',
    createdAt,
    failedOnly = false,
    page = 1,
    pageSize = PAGE_SIZE,
    queryOptions = { enabled: true },
}: SearchWebhookLogsQuery): SearchWebhookLogsResult => {
    const enabled = Boolean(
        queryOptions.enabled !== false
        && agentId
        && webhookId,
    );

    const {
        data, isLoading, isFetching, error,
    } = useHttpQuery<SearchWebhookLogsResponse>({
        key: [
            'search-webhook-logs',
            agentId,
            webhookId,
            createdAt || '',
            failedOnly,
            page,
            pageSize,
        ],
        pathname: buildWebhookLogsSearchPath(agentId),
        method: 'POST',
        server: process.env.REACT_APP_BASE_URL,
        body: buildWebhookLogsListSearchBody({
            webhookId,
            page,
            pageSize,
            createdAt,
            failedOnly,
        }),
        queryOptions: {
            ...queryOptions,
            enabled,
            keepPreviousData: true,
        },
    });

    return {
        data: (data?.hits || []).map(formatWebhookLogFromElasticsearch),
        total: data?.pagination?.total || 0,
        isLoading: isLoading || (enabled && !data && isFetching),
        isFetching,
        error,
    };
};

export default useSearchWebhookLogs;
